import { parseHumanToAtomic } from '@/helpers/amount'
import { ProtobufAnyMessage } from '@/types'

export type TransferFormValues = {
  fromAddress: string
  toAddress: string
  amount: string
  denom: string
}

export function buildTransferMessage(values: TransferFormValues): {
  messages: ProtobufAnyMessage[]
} {
  const amountAtomic = parseHumanToAtomic(values.amount, 18)

  return {
    messages: [
      {
        '@type': '/cosmos.bank.v1beta1.MsgSend',
        fromAddress: values.fromAddress,
        toAddress: values.toAddress,
        amount: [
          {
            denom: values.denom,
            amount: amountAtomic,
          },
        ],
      },
    ],
  }
}
